/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PatientRouteRouteImport } from './routes/patient/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as PractitionerRouteRouteImport } from './routes/_practitioner/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as PractitionerSearchRouteImport } from './routes/_practitioner/search'
import { Route as PractitionerPractitionerBillingRouteImport } from './routes/_practitioner/practitioner-billing'
import { Route as PractitionerPatientSyncRouteImport } from './routes/_practitioner/patient-sync'
import { Route as PractitionerAccountRouteImport } from './routes/_practitioner/account'
import { Route as PractitionerPatientsIndexRouteImport } from './routes/_practitioner/patients.index'
import { Route as PractitionerPatientSyncIndexRouteImport } from './routes/_practitioner/patient-sync.index'
import { Route as PractitionerPatientsPatientIdRouteImport } from './routes/_practitioner/patients.$patientId'
import { Route as PractitionerPatientSyncOngoingImportsRouteImport } from './routes/_practitioner/patient-sync.ongoing-imports'
import { Route as PractitionerPatientSyncLibreviewSelectRouteImport } from './routes/_practitioner/patient-sync.libreview-select'
import { Route as PractitionerPatientsPatientIdIndexRouteImport } from './routes/_practitioner/patients.$patientId.index'
import { Route as PractitionerPatientsPatientIdSettingsRouteImport } from './routes/_practitioner/patients.$patientId.settings'
import { Route as PractitionerPatientsPatientIdPatientManagementRouteImport } from './routes/_practitioner/patients.$patientId.patient-management'
import { Route as PractitionerPatientsPatientIdMedicalFileRouteImport } from './routes/_practitioner/patients.$patientId.medical-file'

const PatientRouteRoute = PatientRouteRouteImport.update({
  id: '/patient',
  path: '/patient',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const PractitionerRouteRoute = PractitionerRouteRouteImport.update({
  id: '/_practitioner',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const PractitionerSearchRoute = PractitionerSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => PractitionerRouteRoute,
} as any)
const PractitionerPractitionerBillingRoute =
  PractitionerPractitionerBillingRouteImport.update({
    id: '/practitioner-billing',
    path: '/practitioner-billing',
    getParentRoute: () => PractitionerRouteRoute,
  } as any)
const PractitionerPatientSyncRoute = PractitionerPatientSyncRouteImport.update({
  id: '/patient-sync',
  path: '/patient-sync',
  getParentRoute: () => PractitionerRouteRoute,
} as any)
const PractitionerAccountRoute = PractitionerAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => PractitionerRouteRoute,
} as any)
const PractitionerPatientsIndexRoute =
  PractitionerPatientsIndexRouteImport.update({
    id: '/patients/',
    path: '/patients/',
    getParentRoute: () => PractitionerRouteRoute,
  } as any)
const PractitionerPatientSyncIndexRoute =
  PractitionerPatientSyncIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PractitionerPatientSyncRoute,
  } as any)
const PractitionerPatientsPatientIdRoute =
  PractitionerPatientsPatientIdRouteImport.update({
    id: '/patients/$patientId',
    path: '/patients/$patientId',
    getParentRoute: () => PractitionerRouteRoute,
  } as any)
const PractitionerPatientSyncOngoingImportsRoute =
  PractitionerPatientSyncOngoingImportsRouteImport.update({
    id: '/ongoing-imports',
    path: '/ongoing-imports',
    getParentRoute: () => PractitionerPatientSyncRoute,
  } as any)
const PractitionerPatientSyncLibreviewSelectRoute =
  PractitionerPatientSyncLibreviewSelectRouteImport.update({
    id: '/libreview-select',
    path: '/libreview-select',
    getParentRoute: () => PractitionerPatientSyncRoute,
  } as any)
const PractitionerPatientsPatientIdIndexRoute =
  PractitionerPatientsPatientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PractitionerPatientsPatientIdRoute,
  } as any)
const PractitionerPatientsPatientIdSettingsRoute =
  PractitionerPatientsPatientIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => PractitionerPatientsPatientIdRoute,
  } as any)
const PractitionerPatientsPatientIdPatientManagementRoute =
  PractitionerPatientsPatientIdPatientManagementRouteImport.update({
    id: '/patient-management',
    path: '/patient-management',
    getParentRoute: () => PractitionerPatientsPatientIdRoute,
  } as any)
const PractitionerPatientsPatientIdMedicalFileRoute =
  PractitionerPatientsPatientIdMedicalFileRouteImport.update({
    id: '/medical-file',
    path: '/medical-file',
    getParentRoute: () => PractitionerPatientsPatientIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/patient': typeof PatientRouteRoute
  '/account': typeof PractitionerAccountRoute
  '/patient-sync': typeof PractitionerPatientSyncRouteWithChildren
  '/practitioner-billing': typeof PractitionerPractitionerBillingRoute
  '/search': typeof PractitionerSearchRoute
  '/admin/': typeof AdminIndexRoute
  '/patient-sync/libreview-select': typeof PractitionerPatientSyncLibreviewSelectRoute
  '/patient-sync/ongoing-imports': typeof PractitionerPatientSyncOngoingImportsRoute
  '/patients/$patientId': typeof PractitionerPatientsPatientIdRouteWithChildren
  '/patient-sync/': typeof PractitionerPatientSyncIndexRoute
  '/patients/': typeof PractitionerPatientsIndexRoute
  '/patients/$patientId/medical-file': typeof PractitionerPatientsPatientIdMedicalFileRoute
  '/patients/$patientId/patient-management': typeof PractitionerPatientsPatientIdPatientManagementRoute
  '/patients/$patientId/settings': typeof PractitionerPatientsPatientIdSettingsRoute
  '/patients/$patientId/': typeof PractitionerPatientsPatientIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/patient': typeof PatientRouteRoute
  '/account': typeof PractitionerAccountRoute
  '/practitioner-billing': typeof PractitionerPractitionerBillingRoute
  '/search': typeof PractitionerSearchRoute
  '/admin': typeof AdminIndexRoute
  '/patient-sync/libreview-select': typeof PractitionerPatientSyncLibreviewSelectRoute
  '/patient-sync/ongoing-imports': typeof PractitionerPatientSyncOngoingImportsRoute
  '/patient-sync': typeof PractitionerPatientSyncIndexRoute
  '/patients': typeof PractitionerPatientsIndexRoute
  '/patients/$patientId/medical-file': typeof PractitionerPatientsPatientIdMedicalFileRoute
  '/patients/$patientId/patient-management': typeof PractitionerPatientsPatientIdPatientManagementRoute
  '/patients/$patientId/settings': typeof PractitionerPatientsPatientIdSettingsRoute
  '/patients/$patientId': typeof PractitionerPatientsPatientIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_practitioner': typeof PractitionerRouteRouteWithChildren
  '/admin': typeof AdminRouteRouteWithChildren
  '/patient': typeof PatientRouteRoute
  '/_practitioner/account': typeof PractitionerAccountRoute
  '/_practitioner/patient-sync': typeof PractitionerPatientSyncRouteWithChildren
  '/_practitioner/practitioner-billing': typeof PractitionerPractitionerBillingRoute
  '/_practitioner/search': typeof PractitionerSearchRoute
  '/admin/': typeof AdminIndexRoute
  '/_practitioner/patient-sync/libreview-select': typeof PractitionerPatientSyncLibreviewSelectRoute
  '/_practitioner/patient-sync/ongoing-imports': typeof PractitionerPatientSyncOngoingImportsRoute
  '/_practitioner/patients/$patientId': typeof PractitionerPatientsPatientIdRouteWithChildren
  '/_practitioner/patient-sync/': typeof PractitionerPatientSyncIndexRoute
  '/_practitioner/patients/': typeof PractitionerPatientsIndexRoute
  '/_practitioner/patients/$patientId/medical-file': typeof PractitionerPatientsPatientIdMedicalFileRoute
  '/_practitioner/patients/$patientId/patient-management': typeof PractitionerPatientsPatientIdPatientManagementRoute
  '/_practitioner/patients/$patientId/settings': typeof PractitionerPatientsPatientIdSettingsRoute
  '/_practitioner/patients/$patientId/': typeof PractitionerPatientsPatientIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/patient'
    | '/account'
    | '/patient-sync'
    | '/practitioner-billing'
    | '/search'
    | '/admin/'
    | '/patient-sync/libreview-select'
    | '/patient-sync/ongoing-imports'
    | '/patients/$patientId'
    | '/patient-sync/'
    | '/patients/'
    | '/patients/$patientId/medical-file'
    | '/patients/$patientId/patient-management'
    | '/patients/$patientId/settings'
    | '/patients/$patientId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/patient'
    | '/account'
    | '/practitioner-billing'
    | '/search'
    | '/admin'
    | '/patient-sync/libreview-select'
    | '/patient-sync/ongoing-imports'
    | '/patient-sync'
    | '/patients'
    | '/patients/$patientId/medical-file'
    | '/patients/$patientId/patient-management'
    | '/patients/$patientId/settings'
    | '/patients/$patientId'
  id:
    | '__root__'
    | '/'
    | '/_practitioner'
    | '/admin'
    | '/patient'
    | '/_practitioner/account'
    | '/_practitioner/patient-sync'
    | '/_practitioner/practitioner-billing'
    | '/_practitioner/search'
    | '/admin/'
    | '/_practitioner/patient-sync/libreview-select'
    | '/_practitioner/patient-sync/ongoing-imports'
    | '/_practitioner/patients/$patientId'
    | '/_practitioner/patient-sync/'
    | '/_practitioner/patients/'
    | '/_practitioner/patients/$patientId/medical-file'
    | '/_practitioner/patients/$patientId/patient-management'
    | '/_practitioner/patients/$patientId/settings'
    | '/_practitioner/patients/$patientId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PractitionerRouteRoute: typeof PractitionerRouteRouteWithChildren
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  PatientRouteRoute: typeof PatientRouteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/patient': {
      id: '/patient'
      path: '/patient'
      fullPath: '/patient'
      preLoaderRoute: typeof PatientRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_practitioner': {
      id: '/_practitioner'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PractitionerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/_practitioner/search': {
      id: '/_practitioner/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof PractitionerSearchRouteImport
      parentRoute: typeof PractitionerRouteRoute
    }
    '/_practitioner/practitioner-billing': {
      id: '/_practitioner/practitioner-billing'
      path: '/practitioner-billing'
      fullPath: '/practitioner-billing'
      preLoaderRoute: typeof PractitionerPractitionerBillingRouteImport
      parentRoute: typeof PractitionerRouteRoute
    }
    '/_practitioner/patient-sync': {
      id: '/_practitioner/patient-sync'
      path: '/patient-sync'
      fullPath: '/patient-sync'
      preLoaderRoute: typeof PractitionerPatientSyncRouteImport
      parentRoute: typeof PractitionerRouteRoute
    }
    '/_practitioner/account': {
      id: '/_practitioner/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof PractitionerAccountRouteImport
      parentRoute: typeof PractitionerRouteRoute
    }
    '/_practitioner/patients/': {
      id: '/_practitioner/patients/'
      path: '/patients'
      fullPath: '/patients/'
      preLoaderRoute: typeof PractitionerPatientsIndexRouteImport
      parentRoute: typeof PractitionerRouteRoute
    }
    '/_practitioner/patient-sync/': {
      id: '/_practitioner/patient-sync/'
      path: '/'
      fullPath: '/patient-sync/'
      preLoaderRoute: typeof PractitionerPatientSyncIndexRouteImport
      parentRoute: typeof PractitionerPatientSyncRoute
    }
    '/_practitioner/patients/$patientId': {
      id: '/_practitioner/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof PractitionerPatientsPatientIdRouteImport
      parentRoute: typeof PractitionerRouteRoute
    }
    '/_practitioner/patient-sync/ongoing-imports': {
      id: '/_practitioner/patient-sync/ongoing-imports'
      path: '/ongoing-imports'
      fullPath: '/patient-sync/ongoing-imports'
      preLoaderRoute: typeof PractitionerPatientSyncOngoingImportsRouteImport
      parentRoute: typeof PractitionerPatientSyncRoute
    }
    '/_practitioner/patient-sync/libreview-select': {
      id: '/_practitioner/patient-sync/libreview-select'
      path: '/libreview-select'
      fullPath: '/patient-sync/libreview-select'
      preLoaderRoute: typeof PractitionerPatientSyncLibreviewSelectRouteImport
      parentRoute: typeof PractitionerPatientSyncRoute
    }
    '/_practitioner/patients/$patientId/': {
      id: '/_practitioner/patients/$patientId/'
      path: '/'
      fullPath: '/patients/$patientId/'
      preLoaderRoute: typeof PractitionerPatientsPatientIdIndexRouteImport
      parentRoute: typeof PractitionerPatientsPatientIdRoute
    }
    '/_practitioner/patients/$patientId/settings': {
      id: '/_practitioner/patients/$patientId/settings'
      path: '/settings'
      fullPath: '/patients/$patientId/settings'
      preLoaderRoute: typeof PractitionerPatientsPatientIdSettingsRouteImport
      parentRoute: typeof PractitionerPatientsPatientIdRoute
    }
    '/_practitioner/patients/$patientId/patient-management': {
      id: '/_practitioner/patients/$patientId/patient-management'
      path: '/patient-management'
      fullPath: '/patients/$patientId/patient-management'
      preLoaderRoute: typeof PractitionerPatientsPatientIdPatientManagementRouteImport
      parentRoute: typeof PractitionerPatientsPatientIdRoute
    }
    '/_practitioner/patients/$patientId/medical-file': {
      id: '/_practitioner/patients/$patientId/medical-file'
      path: '/medical-file'
      fullPath: '/patients/$patientId/medical-file'
      preLoaderRoute: typeof PractitionerPatientsPatientIdMedicalFileRouteImport
      parentRoute: typeof PractitionerPatientsPatientIdRoute
    }
  }
}

interface PractitionerPatientSyncRouteChildren {
  PractitionerPatientSyncLibreviewSelectRoute: typeof PractitionerPatientSyncLibreviewSelectRoute
  PractitionerPatientSyncOngoingImportsRoute: typeof PractitionerPatientSyncOngoingImportsRoute
  PractitionerPatientSyncIndexRoute: typeof PractitionerPatientSyncIndexRoute
}

const PractitionerPatientSyncRouteChildren: PractitionerPatientSyncRouteChildren =
  {
    PractitionerPatientSyncLibreviewSelectRoute:
      PractitionerPatientSyncLibreviewSelectRoute,
    PractitionerPatientSyncOngoingImportsRoute:
      PractitionerPatientSyncOngoingImportsRoute,
    PractitionerPatientSyncIndexRoute: PractitionerPatientSyncIndexRoute,
  }

const PractitionerPatientSyncRouteWithChildren =
  PractitionerPatientSyncRoute._addFileChildren(
    PractitionerPatientSyncRouteChildren,
  )

interface PractitionerPatientsPatientIdRouteChildren {
  PractitionerPatientsPatientIdMedicalFileRoute: typeof PractitionerPatientsPatientIdMedicalFileRoute
  PractitionerPatientsPatientIdPatientManagementRoute: typeof PractitionerPatientsPatientIdPatientManagementRoute
  PractitionerPatientsPatientIdSettingsRoute: typeof PractitionerPatientsPatientIdSettingsRoute
  PractitionerPatientsPatientIdIndexRoute: typeof PractitionerPatientsPatientIdIndexRoute
}

const PractitionerPatientsPatientIdRouteChildren: PractitionerPatientsPatientIdRouteChildren =
  {
    PractitionerPatientsPatientIdMedicalFileRoute:
      PractitionerPatientsPatientIdMedicalFileRoute,
    PractitionerPatientsPatientIdPatientManagementRoute:
      PractitionerPatientsPatientIdPatientManagementRoute,
    PractitionerPatientsPatientIdSettingsRoute:
      PractitionerPatientsPatientIdSettingsRoute,
    PractitionerPatientsPatientIdIndexRoute:
      PractitionerPatientsPatientIdIndexRoute,
  }

const PractitionerPatientsPatientIdRouteWithChildren =
  PractitionerPatientsPatientIdRoute._addFileChildren(
    PractitionerPatientsPatientIdRouteChildren,
  )

interface PractitionerRouteRouteChildren {
  PractitionerAccountRoute: typeof PractitionerAccountRoute
  PractitionerPatientSyncRoute: typeof PractitionerPatientSyncRouteWithChildren
  PractitionerPractitionerBillingRoute: typeof PractitionerPractitionerBillingRoute
  PractitionerSearchRoute: typeof PractitionerSearchRoute
  PractitionerPatientsPatientIdRoute: typeof PractitionerPatientsPatientIdRouteWithChildren
  PractitionerPatientsIndexRoute: typeof PractitionerPatientsIndexRoute
}

const PractitionerRouteRouteChildren: PractitionerRouteRouteChildren = {
  PractitionerAccountRoute: PractitionerAccountRoute,
  PractitionerPatientSyncRoute: PractitionerPatientSyncRouteWithChildren,
  PractitionerPractitionerBillingRoute: PractitionerPractitionerBillingRoute,
  PractitionerSearchRoute: PractitionerSearchRoute,
  PractitionerPatientsPatientIdRoute:
    PractitionerPatientsPatientIdRouteWithChildren,
  PractitionerPatientsIndexRoute: PractitionerPatientsIndexRoute,
}

const PractitionerRouteRouteWithChildren =
  PractitionerRouteRoute._addFileChildren(PractitionerRouteRouteChildren)

interface AdminRouteRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PractitionerRouteRoute: PractitionerRouteRouteWithChildren,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  PatientRouteRoute: PatientRouteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
